




































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Zone } from "@/types";
import BorderNavButton from "@/components/BorderNavButton.vue";
import PlantBackground from "@/components/PlantBackground.vue";
import { className } from "@/utilities";

@Component({
  components: { BorderNavButton, PlantBackground },
})
export default class AboutView extends Vue {
  @Watch("$route", { immediate: true, deep: true })
  routeChanged(to: any, from: any) {
    const zones = Object.keys(this.$store.state.garden.zones);
    const name = this.$route.params.zone;
    const zoneIndex = zones.indexOf(name);

    const prevName = zoneIndex > 0 && zones[zoneIndex - 1];
    const nextName =
      zoneIndex > -1 && zoneIndex < zones.length - 1 && zones[zoneIndex + 1];
    const prev = prevName && { path: `/tuin/${prevName}` };
    const next = nextName && { path: `/tuin/${nextName}` };

    this.$store.dispatch("setNavigation", {
      up: { path: "/tuin" },
      next,
      prev,
    });
  }
}
